import styled from 'styled-components'
import { allTransitions } from 'transitions/app-transitions'

const Page = styled.div.attrs(()=> ({
    id: "ns-page"
}))`
    display: flex;
    width: 100%;
    flex-direction: column;
    backface-visibility: hidden;
    min-height: 100%;
    ${allTransitions}
`

export default Page
